<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="user-guide">
      <Title jpn="ご利用ガイド" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="① 会員登録"
        >
          <div class="text-container">
            <span class="text">本サイトをご利用いただくには、会員登録（無料）が必要となります。</span>
            <br>
            <span class="text">※会員登録にはメールアドレスが必要です。</span>
            <span class="text">GmailまたはYahooメールのご利用を推奨しております。</span>
            <br>
            <span class="text">また、アカウントはお一人様につき1アカウントまでとさせていただいております。</span>
            <br>
            <span class="text">同一人物による複数アカウントの利用が確認された場合、</span>
            <span class="text">アカウントの利用制限または停止措置を行う場合がございます。</span>
            <br>
            <span class="text">なお、以下の場合には本人確認書類の提出をお願いする場合がございます。</span>
            <br>
            <span class="text">・同一住所で複数名義の登録が確認された場合</span>
            <span class="text">・同一名義で複数住所の登録が確認された場合</span>
            <span class="text">・同一端末で複数アカウントの利用が確認された場合</span>
            <span class="text">・決済会社または関係機関より不正利用の疑いがあるとの連絡があった場合</span>
            <span class="text">・住所情報に明らかな不備がある場合</span>
            <span class="text">・虚偽の情報で登録されていると判断された場合</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="② ポイント購入"
        >
          <div class="text-container">
            <span class="text">本サイトでは、ポイントを利用して商品をご購入いただきます。</span>
            <br>
            <span class="text">1P＝1円としてご利用いただけます。</span>
            <br>
            <span class="text bold">購入可能ポイント</span>
            <span class="text">500P〜300,000P</span>
            <br>
            <span class="text bold">利用可能な決済方法</span>
            <span class="text">・クレジットカード決済</span>
            <span class="text">・コンビニ決済</span>
            <span class="text">・キャリア決済</span>
            <span class="text">・メルペイ</span>
            <span class="text">・その他</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="③ ガチャ購入"
        >
          <div class="text-container">
            <span class="text">商品ページから購入数を選択すると、演出動画が再生されます。</span>
            <br>
            <span class="text">演出動画の演出により排出されるカードの内容が決定します。</span>
            <br>
            <span class="text">※複数回購入された場合、購入回数分の演出が再生されます。</span>
            <span class="text">※演出動画はスキップすることが可能です。</span>
            <br>
            <span class="text">排出後、以下のいずれかを選択していただきます。</span>
            <br>
            <span class="text bold">・ポイント還元</span>
            <span class="text bold">・発送依頼</span>
            <br>
            <span class="text">※選択後の変更はできません。</span>
            <span class="text">※24時間以内に選択が行われない場合、自動的にポイント還元となります。</span>
            <br>
            <span class="text bold">ポイント還元</span>
            <span class="text">排出されたカードの代わりに、同等の還元ポイントが付与されます。</span>
            <span class="text">付与されたポイントは次回以降のガチャ購入にご利用いただけます。</span>
            <br>
            <span class="text bold">発送依頼</span>
            <span class="text">排出されたカードを実際に発送いたします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          id="rank-system"
          class="shadow-box-title-description"
          title="④ 会員ランク制度"
        >
          <div class="text-container">
            <span class="text">会員ランクは累計購入ポイントに応じて決定されます。</span>
            <br>
            <span class="text">※ランクは毎月1日0時に1段階下がります。</span>
            <br>
            <div class="rank-table">
              <div class="rank-row rank-header">
                <span class="rank-name">ランク</span>
                <span class="rank-condition">当月課金P数</span>
                <span class="rank-discount">割引率</span>
              </div>
              <div class="rank-row">
                <span class="rank-name">ホワイト会員</span>
                <span class="rank-condition">〜99,999P</span>
                <span class="rank-discount">0%</span>
              </div>
              <div class="rank-row">
                <span class="rank-name">ブロンズ会員</span>
                <span class="rank-condition">100,000P〜299,999P</span>
                <span class="rank-discount">1%</span>
              </div>
              <div class="rank-row">
                <span class="rank-name">シルバー会員</span>
                <span class="rank-condition">300,000P〜799,999P</span>
                <span class="rank-discount">2%</span>
              </div>
              <div class="rank-row">
                <span class="rank-name">ゴールド会員</span>
                <span class="rank-condition">800,000P〜1,499,999P</span>
                <span class="rank-discount">4%</span>
              </div>
              <div class="rank-row">
                <span class="rank-name">プラチナ会員</span>
                <span class="rank-condition">1,500,000P〜2,499,999P</span>
                <span class="rank-discount">6%</span>
              </div>
              <div class="rank-row">
                <span class="rank-name">レインボー会員</span>
                <span class="rank-condition">2,500,000P以上</span>
                <span class="rank-discount">8%</span>
              </div>
            </div>
            <br>
            <span class="text">レインボー会員 特典：カード詰め合わせセットプレゼント</span>
            <br>
            <div class="rank-table">
              <div class="rank-row">
                <span class="rank-name">エターナルブラック会員</span>
                <span class="rank-condition">累計課金50,000,000P</span>
                <span class="rank-discount">8%（永続）</span>
              </div>
            </div>
            <br>
            <span class="text">エターナルブラック会員 特典：カード詰め合わせセットプレゼント</span>
            <br>
            <span class="text">※特典内容は変更される場合があります。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="⑤ 発送について"
        >
          <div class="text-container">
            <span class="text bold">配送業者</span>
            <span class="text">・ヤマト運輸</span>
            <span class="text">・佐川急便</span>
            <span class="text">・その他</span>
            <br>
            <span class="text bold">送料</span>
            <span class="text">全国一律無料</span>
            <br>
            <span class="text bold">発送依頼後</span>
            <span class="text">14日前後で発送</span>
            <br>
            <span class="text">発送完了後、追跡番号をメールにてお知らせいたします。</span>
            <br>
            <span class="text">※発送元が異なる場合、商品が別送となる場合があります。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="⑥ 商品状態について"
        >
          <div class="text-container">
            <span class="text">本サイトで取り扱う商品はすべて中古品となります。</span>
            <br>
            <span class="text">そのため、カードには以下が含まれる場合があります。</span>
            <br>
            <span class="text">・微細なキズ</span>
            <span class="text">・白かけ</span>
            <span class="text">・初期キズ</span>
            <br>
            <span class="text">これらは商品の性質上避けられない場合があるため、</span>
            <span class="text">状態を理由とした返品・交換はお受けできません。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="⑦ 鑑定カードについて"
        >
          <div class="text-container">
            <span class="text">鑑定カードは各鑑定機関の評価基準に基づき販売しております。</span>
            <br>
            <span class="text">ケース内部のカードの状態や異物等については返品・交換の対象外となります。</span>
            <br>
            <span class="text">また、ARS鑑定品については鑑定書が付属しない場合があります。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="⑧ 商品画像について"
        >
          <div class="text-container">
            <span class="text">商品画像はイメージ画像を使用する場合があります。</span>
            <br>
            <span class="text">排出されるカードは、</span>
            <span class="text">商品名および還元ポイント情報を基準として判断されます。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="⑨ 不正行為について"
        >
          <div class="text-container">
            <span class="text">以下の行為が確認された場合、アカウントの利用制限または停止措置を行う場合があります。</span>
            <br>
            <span class="text">・複数アカウントの利用</span>
            <span class="text">・不正アクセス</span>
            <span class="text">・抽選の公平性を損なう行為</span>
            <span class="text">・その他当店が不適切と判断した行為</span>
            <br>
            <span class="text">不正行為が確認された場合、該当取引の無効化やポイントの取り消し等の対応を行う場合があります。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="⑩ サービスの運営について"
        >
          <div class="text-container">
            <span class="text">本サービスはシステムの保守、運営上の理由により</span>
            <span class="text">一時的にメンテナンスを行う場合があります。</span>
            <br>
            <span class="text">その際は事前または事後にお知らせいたします。</span>
            <br>
            <span class="text">最後までお読みいただき、誠にありがとうございました。</span>
            <span class="text">今後とも本サービスをよろしくお願いいたします。</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'UserGuide',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },

  mounted() {
    if (this.$route.hash) {
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector(this.$route.hash);
          if (el) {
            const y = el.getBoundingClientRect().top + window.scrollY - 90;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }, 300);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.user-guide{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          &.bold{
            font-weight: 700;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
        .rank-table{
          width: 100%;
          border: 1px solid #ccc;
          border-radius: 8px;
          overflow: hidden;
          .rank-row{
            display: flex;
            border-bottom: 1px solid #e0e0e0;
            &:last-child{
              border-bottom: none;
            }
            &.rank-header{
              background: #f0f0f0;
              font-weight: 700;
            }
            .rank-name,
            .rank-condition,
            .rank-discount{
              padding: 8px 10px;
              font-family: $notoSans;
              font-size: 12px;
              line-height: 1.5;
            }
            .rank-name{
              width: 40%;
            }
            .rank-condition{
              width: 40%;
            }
            .rank-discount{
              width: 20%;
              text-align: center;
            }
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .user-guide {
    .scroll-container {
      .shadow-box-title-description {
        .text-container {
          span.text {
            font-size: 12px;
          }
          .rank-table .rank-row {
            .rank-name,
            .rank-condition,
            .rank-discount {
              font-size: 10px;
              padding: 6px 5px;
            }
          }
        }
      }
    }
  }
}
</style>
